import React from 'react'
import "bootstrap/js/src/collapse.js";
import bolt from '../img/Bolt-Logo.jpg';
import '../css/header.css';

const Header = () => {
  return (
    <div className='container'>
      <nav className="navbar navbar-expand-lg navbar-light ">
        <a className="navbar-brand" href="#">
          <img src={bolt} alt='bolt logo' height={30}/>
        </a>
        <div>
          <button className='bolt-btn btn btn-sm rounded-pill mr-3 d-lg-none'>Log In</button>          
          <button className="navbar-toggler btn-sm" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item mx-2">
              <a className="nav-link" href="#">Ride</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href="#">Become a driver</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href="#">Fleet</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href='#'>Business</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href='#'>Scooters</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href='#'>Drive</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href='#'>Food</a>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href='#'>Cities</a>
            </li>
          </ul>
        </div>
        <button className='bolt-btn btn btn-sm rounded-pill d-none d-lg-inline-block font-weight-bold'>Log in</button>

      </nav>
    </div>
  )
}

export default Header;
